export * from '@taqueria/protocol/out/types/Faucet';
